module.exports = __webpack_public_path__ + "img/vaccineCovid.2b8dcee2.jpg";